import React from 'react';
import './index.scss';
interface EnableProps {
  vehicleName?: string;
  disabled: boolean;
  enable: {
    front: boolean | undefined;
    back: boolean | undefined;
    left: boolean | undefined;
    right: boolean | undefined;
  } | null;
}

const EnableComponent = (props: EnableProps) => {
  const { vehicleName, enable, disabled } = props;
  return (
    <>
      {disabled || !enable ? (
        <div className='fault-box'>
          <div className='center-con vh-center'></div>
          <div className='top-con lost'></div>
          <div className='bottom-con lost'></div>
          <div className='left-con lost'></div>
          <div className='right-con lost'></div>
        </div>
      ) : (
        <>
          {vehicleName && <div className='license'> {vehicleName}</div>}
          <div className='fault-box'>
            <div className='center-con vh-center'></div>
            <div className={enable.front ? 'top-con' : 'top-con error'}></div>
            <div
              className={enable.back ? 'bottom-con' : 'bottom-con error'}
            ></div>
            <div className={enable.left ? 'left-con' : 'left-con error'}></div>
            <div
              className={enable.right ? 'right-con' : 'right-con error'}
            ></div>
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(EnableComponent);
